export default __webpack_public_path__ + "static/media/robotloading.359e8863.gif";